
export class Color {
    static primary = '#030678';
    static info = '#0099CC';
}